export default __webpack_public_path__ + "static/media/img-1.01b7bf26.jpg";